import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/users/seller/new',
  title: 'Cadastro Vendedor',
  endpoint: '/app/person',
}
